// Strasse/Hausnummer (25.10.2026): Neuanlage aus Beschluss und Schnellerfassung speichern `strasse`/`hausnummer`, aeltere Akten `adresse`.
export const strasseZeile = (k) => k?.adresse || [k?.strasse, k?.hausnummer].filter(Boolean).join(' ') || null;
